import * as React from 'react'

import {Button, Checkbox, Form, Icon, Input} from 'antd';
import {FormComponentProps} from "antd/lib/form";
import styles from "./index.scss"
import {observer} from "mobx-react";
import {action} from "mobx";
import {ViewBaseComponent} from "../../../src/views/ViewComponentBase";
import {errorsStore} from "../../../src/store/common/Errors/ErrorsStore";
import {adminApiWrapper} from "../../../src/common/Api/Admin/adminApiWrapper";
import {redirect} from "../../../src/common/Router/routerCommon";
import {renderErrorMapMessage} from "../../../src/utils/react/error";
import {BaseApiResponse, LoginApi, LoginLoginRequest} from "../../../src/swagger";
import {createApiConfiguration} from "../../../src/utils/apiFactory";
import KixGbcMemberLayout from "../../layouts/KixGbcMemberLayout/KixGbcMemberLayout";
import commonStyles from '../../../src/styles/common.scss';
import appStyles from '../../assets/css/app.scss';
import {Link} from "react-router-dom";
import {safeRedirect} from "../../../src/utils/redirect/safeRedirect";

const FormItem = Form.Item;

@observer
class Login extends ViewBaseComponent<{} & FormComponentProps, {}> {

  // ログインAPI実行
  @action
  handleSubmit = (e: React.SyntheticEvent<EventTarget>) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let adminLoginRequest = values as LoginLoginRequest

        errorsStore.clearErrors("getLoginUser");

        let api = new LoginApi(createApiConfiguration());
        adminApiWrapper(() => {
            return api.login(adminLoginRequest)
          }
          , "getLoginUser"
        ).then((_res: BaseApiResponse) => {
          redirect("/");
        });
      }
    });
  }

  render() {
    const {getFieldDecorator} = this.props.form;

    return (
      <KixGbcMemberLayout notLogout={true}>
        <div className={commonStyles.fCenter} style={{paddingTop: "5em"}}>
          <Form onSubmit={this.handleSubmit} autoComplete="off">
            <div>
              <div className={`${styles["login-form"]} loginForm`} style={{marginBottom: "5em"}}>
                {renderErrorMapMessage(errorsStore.errorMap)}
                <FormItem>
                  {getFieldDecorator('userCode', {
                    rules: [{required: true, message: '入力して下さい'}],
                  })(
                    <Input size="large" prefix={<Icon type="user" style={{color: "#969696", fontSize: "2em"}}/>}
                           placeholder="会員IDまたはメールアドレスを入力してください"/>
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('password', {
                    rules: [{required: true, message: '入力して下さい'}],
                  })(
                    <Input size="large" prefix={<Icon type="lock" style={{color: "#969696", fontSize: "2em"}}/>}
                           type="password"
                           name="password"
                           autoComplete="off"
                           placeholder="パスワードを入力してください"/>
                  )}
                </FormItem>

                <div style={{textAlign: 'right'}}>
                  <Link className={appStyles.darkBlueLink} to={"/password_reset"}>パスワードをお忘れの方</Link>
                </div>
                <div>
                  <FormItem>
                    {getFieldDecorator('kiyaku_check', {
                      rules: [{required: true, message: '選択して下さい'}],
                    })(
                      <Checkbox.Group>
                        <Checkbox value={"1"}>
                          <a className={appStyles.darkBlueLink} target={"blank"} href={"https://www.kansai-airport.or.jp/static/images/kix-gbc/pamph/kiyaku.pdf"}>会員規約</a><span
                          style={{color: "white"}}>に同意</span>
                        </Checkbox>
                      </Checkbox.Group>
                    )}
                  </FormItem>
                </div>

                <div style={{display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '10px', marginTop: '30px'}}>
                  <FormItem style={{marginBottom: 0}}>
                    <Button style={{padding: "0.5em 3em"}} type="primary"
                            htmlType="submit" size="large" className={appStyles.buttonWhiteRadius}>
                      ログイン
                    </Button>
                  </FormItem>
                  <FormItem style={{marginBottom: 0}}>
                    <Button style={{padding: "0.5em 3em"}} type="primary" size="large"
                            className={appStyles.buttonGrayRadius}
                            onClick={() => safeRedirect("https://www.kansai-airport.or.jp/kix-gbc/")}>
                      キャンセル
                    </Button>
                  </FormItem>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </KixGbcMemberLayout>
    )
  }
}

export default Form.create()(Login)

